var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import getId from "@irati/utils/id";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import DealModes from "../../../enums/DealModes";
import DealHeaderDetails from "../../DealHeaderDetails";
import UnavailableDealHeaderDetails from "../../DealHeaderDetails/UnavailableDealHeaderDetails";
import UnavailableDeal from "./UnavailableDeal";
import { AvailableCardDeal, UnavailableCardDeal } from "./styled";
var DealBody = function (_a) {
    var deal = _a.deal, borderBottomColor = _a.borderBottomColor, isFavouriteDeal = _a.isFavouriteDeal, _b = _a.mode, mode = _b === void 0 ? DealModes.Default : _b, props = __rest(_a, ["deal", "borderBottomColor", "isFavouriteDeal", "mode"]);
    var idNamespace = getId("card", props);
    return (React.createElement(React.Fragment, null,
        isDealUnavailable(deal) && (React.createElement(UnavailableCardDeal, { id: getId("unavailable", idNamespace) },
            React.createElement(UnavailableDealHeaderDetails, { deal: deal, mode: mode }),
            React.createElement(UnavailableDeal, { isFavouriteDeal: isFavouriteDeal }))),
        !isDealUnavailable(deal) && (React.createElement(AvailableCardDeal, { id: getId("available", idNamespace), borderBottomColor: borderBottomColor },
            React.createElement(DealHeaderDetails, { deal: deal, mode: mode })))));
};
export default DealBody;
